import React from 'react';
import { createComponent } from '@lit/react';
import { IxPricing as LitComp } from '../IxPricing.js';

customElements.define('ix-pricing', LitComp);

export const IxPricing = createComponent({
  tagName: 'ix-pricing-react',
  elementClass: LitComp,
  react: React,
});
